import api from './api';

export const getTimeLogs = (params) => api.get('/time', { params });
export const createTimeLog = (data) => api.post('/time', data);
export const updateTimeLog = (logId, data) => api.patch(`/time/${logId}`, data);
export const deleteTimeLog = (logId) => api.delete(`/time/${logId}`);

export const exportTimeCSV = async (year) => {
  const res = await api.get('/time/export', {
    params: { year },
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `time-${year}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
